import { defineNuxtPlugin } from '#imports'

export default defineNuxtPlugin({
  name: 'critical-styles',
  enforce: 'pre',
  setup() {
    if (!process.client) return

    // Add loaded class after hydration to enable transitions
    const addLoadedClass = () => {
      document.body.classList.add('loaded')
    }

    // Add loaded class immediately if document is already loaded
    if (document.readyState === 'complete') {
      addLoadedClass()
    } else {
      // Wait for load event
      window.addEventListener('load', addLoadedClass)
    }

    // Also add after a short delay as fallback
    setTimeout(addLoadedClass, 100)
  }
})